export function formatMemberIdDisplay(id: string) {
  const d = id.replace(/\D/g, "");
  if (d.length === 12) return `${d.slice(0, 4)}-${d.slice(4, 8)}-${d.slice(8, 12)}`;
  return id;
}
